import { UtilityService } from '../../services/utility.service';
import { ImageManagerService } from '../managers/image-manager.service';
import { CommCardDetailed } from './comm-card/comm-card-detailed.model';
import { ImageAsset } from './image-asset.model';
import { ToroControllerConfiguration } from './toro-controller-configuration.model';
import { ToroController } from './toro-controller.model';

export class ToroControllerBundle
{

    constructor(json: any = null,
                protected imageManager: ImageManagerService
    )
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json.Controller) this.Controller = new ToroController(json.Controller);
            if (json.Configuration) this.Configuration = new ToroControllerConfiguration(json.Configuration);
            if (json.CommCard) this.CommCard = new CommCardDetailed(json.CommCard);
        }

    }

    // =========================================================================================================================================================
    // Station Runtime Info - Begin
    // =========================================================================================================================================================

    maxStationRuntimeInHours = 12;

    get maxStationRuntimeInSeconds(): number
    {
        return this.maxStationRuntimeInHours * 60 * 60;
    }

    get maxStationRunTimeStringForProgram(): string
    {
        return `Max: ${Math.floor(this.maxStationRuntimeInHours)}h ${this.maxStationRuntimeInHours * 60 % 60}m`;
    }

    get maxStationRuntimeHourString(): string
    {
        return `${UtilityService.pad(Math.trunc(this.maxStationRuntimeInHours), 2)}:${Math.trunc((this.maxStationRuntimeInHours % 1) * 60)}`;
    }

    // =========================================================================================================================================================
    // Station Runtime Info - End
    // =========================================================================================================================================================

    maxStationCycleTimeInHours = 12;
    maxStationSoakTimeInHours = 12;

    DeviceType: string;
    Controller: ToroController;
    Configuration: ToroControllerConfiguration;
    CommCard: CommCardDetailed;
    maxProgramStartTimeInMinuteOfDay = 65535;
    minTestAllStationsInMins = 1;
    maxTestAllStationsInMins = 99;
    showWaterBudgetForProgram = false;
    showMonthlyPercentAdjust = false;
    showClimateLogicSettings = false;
    showClimateLogicType = false;
    canUpdateNumberOfStations = true;
    showGetControllerConfiguration = false;
    showResyncCommCard = false;
    showImportConfiguration = false;
    showExportConfiguration = false;
    showSensorState = false;
    dryOutDaysList = [];
    freezeOffTemperatureList = [];
    currentIntervalDayLabel = 'Current Day';
    hasSameValuesForWeekdaysAndIntervalDays = false;
    treatUnitsAsTemperature = false;
    imageAsset: ImageAsset;
    timeFormats = [
        { Text: '12 Hour', Value: 0 },
        { Text: '24 Hour', Value: 1 }
    ];

}
